import sprayService from '../services/sprayService'
import sprayRepo from '../repos/sprayRepo';
import sprayApi from '@/api/sprayApi';

export default  {
    namespaced: true,
    state: {
        masterData: null,
        uiState: {
            networkError: false
        },
        totalUnSyncedSpraies: {
            unUpdateSpraies: 0, unAddSpraies: 0, unDeleteSpraies: 0
        }
    },
    getters: {
        getMasterData(state) {
            return state.masterData;
        },
        getTotalUnSyncedSpraies(state) {
            return state.totalUnSyncedSpraies;
        },
        getPlants(state) {
            if(state.masterData) {
                return state.masterData.Plants;
            }

            return null;
        },
        getDivisions(state) {
            return (plantID) => {
                if(plantID) {
                    if(plantID > 0) {
                        return state.masterData.Divisions.filter(d=> {
                            return plantID == d.PlantID;
                        })
                    }   else {
                        return state.masterData.Divisions;
                    }
                    
                } else {
                    return []; 
                }
            }
        },
        getLocations(state) {
            return (divisonID) => {
                if(divisonID) {
                    if(divisonID > 0) {
                    return state.masterData.Locations.filter(l=> divisonID == l.DivisionID);
                    } else {
                        return state.masterData.Locations;
                    }
                } else {
                    return [];
                }
            }
        },
        getDivisionsForPlants(state) {
            if(state.masterData && state.masterData.Plants && state.masterData.Plants.length > 0) {
                return state.masterData.Divisions.filter(d=> state.masterData.Plants.find(p=> d.PlantID == p.PlantID))   
            } else {
                return []; 
            }
        },
        getLocationsForPlants(state, getters) {
            if(state.masterData && state.masterData.Plants && state.masterData.Plants.length > 0 && state.masterData.Divisions && state.masterData.Divisions.length > 0) {
                return state.masterData.Locations.filter(l=> getters.getDivisionsForPlants.find(d=> d.DivisionID == l.DivisionID));
            } else {
                return [];
            }
        },
        getSprayConfigurations(state) {
            if(state.masterData) {
                return state.masterData.SprayConfigurations;
            }

            return null;
        },
        getSpraies(state) {
            return (plantIDs, divisionIDs, locationIDs) => {
                if(state.masterData.Spraies) {
                return state.masterData.Spraies.filter(s=> {
                    var match = true;
                    if(plantIDs && plantIDs.length > 0 && plantIDs.indexOf(s.PlantID) < 0) {
                        match = false;
                    }
                    if(divisionIDs && divisionIDs.length > 0 && divisionIDs.indexOf(s.DivisionID) < 0) {
                        match = false;
                    }
                    if(locationIDs && locationIDs.length > 0 && locationIDs.indexOf(s.LocationID) < 0) {
                        match = false;
                    }
                    return match;
                }).map(s=> {
                    var location = state.masterData.Locations.find(l=> l.LocationID == s.LocationID);
                    s.LocationName = location? location.LocationName : "";
                    var division = state.masterData.Divisions.find(d=> d.DivisionID == s.DivisionID);
                    s.DivisionName = division? division.DivisionName : "";
                    var plant = state.masterData.Plants.find(p=> p.PlantID == s.PlantID);
                    s.PlantName = plant? plant.PlantName: "";
                    var sprayConfiguration = state.masterData.SprayConfigurations.find(sc=> sc.SprayConfigurationID == s.SprayConfigurationID);
                    if(sprayConfiguration) {
                        s.ProductChemical = sprayConfiguration.ProductChemical;
                        var sprayDateTime = new Date(s.SprayDateTime);
                        s.WithholdDateTime = sprayDateTime.setHours(sprayDateTime.getHours() + sprayConfiguration.WithholdPeriod);
                        var withholdDateTime = new Date(s.WithholdDateTime);
                        s.ValidDateTime = withholdDateTime.setHours(withholdDateTime.getHours() + sprayConfiguration.ValidPeriod);
                    }
                    return s;
                
                });
               
            } else {
                return [];
            }
            }
        }
    }, 
    mutations: {
        setNetworkError(state, value){
            state.uiState.networkError = value;
        },
        updateMasterData(state, masterData) {
            state.masterData = masterData;
        },
        updateTotalUnSyncedSpraies(state, totalUnSyncedSpraies) {
            state.totalUnSyncedSpraies = totalUnSyncedSpraies;
        }
    },
    actions: {
        async handleOffline({ commit }, options){
            try {
                await options.action();
                commit("setNetworkError", false);
            } catch(e){
                commit("setNetworkError", true);
            }
        },
        async updateTotalUnsyncedSpraies({commit}) {
            var totalUnSyncedSpraies = await sprayService.getTotalUnSyncedSpraies();
            commit("updateTotalUnSyncedSpraies", totalUnSyncedSpraies);
        },
        async syncUnsyncedData({dispatch}) {
            await dispatch("handleOffline", {
                async action(){
                    await sprayService.postUnSyncedData();
                }
            });
            await dispatch("loadMasterDataAsync");

        },
        async loadMasterDataAsync({ commit, dispatch }) {
            // Try to load from the server and if we go offline then just continue and try to load from indexdb.
            await dispatch("handleOffline", {
                async action(){
                    await sprayService.fetchAndStoreMasterData();
                }
            });

            // Load from indexdb
            let masterData = await sprayRepo.getMasterData();
            commit('updateMasterData', masterData);
            await dispatch("updateTotalUnsyncedSpraies");

        },
        async addSpray({ dispatch }, spray){
            // Add new spray to server
            await dispatch("handleOffline", {
                async action(){
                    await sprayService.addSpray(spray);
                }
            });
            await dispatch("loadMasterDataAsync");
        },
        async updateSpray({ dispatch }, spray){
            // Add new spray to server
            await dispatch("handleOffline", {
                async action(){
                    await sprayService.updateSpray(spray);
                }
            });

            await dispatch("loadMasterDataAsync");

        },
        async deleteSpray({ dispatch }, spray){
            // Add new spray to server
            await dispatch("handleOffline", {
                async action(){
                    await sprayService.deleteSpray(spray);
                }
            });
            await dispatch("loadMasterDataAsync");
        },
        async importSpray(context, file) {
            return await sprayApi.importSpray(file);
        }
    }
}

